import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const pct = (a, b) => (!b ? 0 : Math.round((a / b) * 100));
export const fK  = (n) => "$" + (Math.round(n / 100) / 10).toFixed(1) + "K";
export const fmt = (n) => "$" + Number(n).toLocaleString();
export const daysLeft = (iso) => Math.ceil((new Date(iso) - new Date()) / 86_400_000);
export const ini = (n) => (n || "?").split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();
export const uid = () => "id_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
export const todayISO = () => new Date().toISOString().split("T")[0];

const PILL_MAP = {
  "Completed": "green", "Complete": "green", "On Track": "green", "Champion": "green",
  "Supporter": "green", "Full Fit": "green", "Done": "green",
  "In Progress": "blue", "Active": "blue", "Lead": "blue",
  "Overdue": "red", "Escalated": "red", "Critical": "red", "Monitor": "red",
  "No Fit": "red", "Off Track": "red",
  "Not Started": "neutral", "Upcoming": "neutral", "Neutral": "neutral",
  "In Review": "purple", "Partial Fit": "purple", "Monitoring": "purple",
  "Open": "amber", "Medium": "amber", "High": "amber", "At Risk": "amber",
  "Low": "neutral",
};
export const statusClass = (s) => "pill-" + (PILL_MAP[s] || "neutral");

export function debounce(fn, ms = 600) {
  let t;
  const debounced = (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
  debounced.flush = () => clearTimeout(t);
  return debounced;
}

let _toastTimer;
export function toast(msg) {
  let el = document.getElementById("global-toast");
  if (!el) {
    el = document.createElement("div");
    el.id = "global-toast";
    el.className = "toast";
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add("show");
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => el.classList.remove("show"), 2200);
}
